import { Dropdown } from "primereact/dropdown";
import { PlusCircle } from "lucide-react";
import { useSelector } from "react-redux";

const PurchaseOrderFields = ({ form, handleChange, error, data, onAddParty }) => {
  const orderByData =
    useSelector((state) => state.getGenMaster?.user?.data) || [];
  const projectData =
    useSelector((state) => state.getProject?.user?.data) || [];
  const partyData = useSelector((state) => state.getParty?.user?.data) || [];
  const getPaymentData =
    useSelector((state) => state?.getPaymentList?.user?.data?.list) || [];

  const quotationData =
    useSelector((state) => state?.getQuotationData?.user?.data) || [];


  return (
    <>
      <div className="row">
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              Project <span className="login-danger">*</span>
            </label>
            <Dropdown
              value={form.project_id}
              options={projectData?.map((e) => ({
                label: e.project_no ? `${e.name} (${e.project_no})` : e.name,
                value: e._id,
              }))}
              onChange={(e) =>
                handleChange({ target: { name: "project_id", value: e.value } })
              }
              placeholder="Select Project"
              filter
              className="w-100"
              disabled={data?._id}
            />
            <div className="error">{error?.project_id_err}</div>
          </div>
        </div>
        {/* <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>Project No</label>
            <input
              type="text"
              name="manual_pro_no"
              placeholder="Enter Project No"
              value={form?.manual_pro_no || ""}
              onChange={handleChange}
              className="form-control"
            />
          </div>
        </div> */}
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              Party <span className="login-danger">*</span>
            </label>
            <div className="d-flex gap-2">
              <div className="flex-grow-1">
                <Dropdown
                  value={form.party_id}
                  options={partyData?.map((e) => ({ label: e.name, value: e._id }))}
                  onChange={(e) =>
                    handleChange({ target: { name: "party_id", value: e.value } })
                  }
                  placeholder="Select Party"
                  filter
                  className="w-100"
                  disabled={data?._id}
                />
              </div>
              {!data?._id && onAddParty && (
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary mt-1 d-flex align-items-center justify-content-center"
                  style={{ width: "40px", height: "38px" }}
                  onClick={onAddParty}
                >
                  <PlusCircle size={16} />
                </button>
              )}
            </div>
            <div className="error">{error?.party_id_err}</div>
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>Quotation No</label>
            <Dropdown
              value={form.quotation_id}
              options={quotationData?.map((e) => ({
                label: e.voucher_no,
                value: e._id,
              }))}
              onChange={(e) =>
                handleChange({
                  target: { name: "quotation_id", value: e.value },
                })
              }
              placeholder="Select Quotation No"
              filter
              className="w-100"
            />
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              Payment Method <span className="login-danger">*</span>
            </label>
            <Dropdown
              value={form.payment_method_id}
              options={getPaymentData?.map((e) => ({
                label: e.name,
                value: e._id,
              }))}
              onChange={(e) =>
                handleChange({
                  target: { name: "payment_method_id", value: e.value },
                })
              }
              placeholder="Select Payment Method"
              filter
              className="w-100"
            />
            {error.payment_err && (
              <div className="error">{error.payment_err}</div>
            )}
          </div>
        </div>
        {data?._id && (
          <div className="col-12 col-md-4 col-xl-4">
            <div className="input-block local-forms">
              <label>Order No.</label>
              <input
                type="text"
                className="form-control"
                value={data?.voucher_no}
                readOnly
              />
            </div>
          </div>
        )}
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              Date <span className="login-danger">*</span>
            </label>
            <input
              type="date"
              className="form-control"
              name="trans_date"
              onChange={handleChange}
              value={form.trans_date}
            />
            {error.trans_date && (
              <div className="error">{error.trans_date}</div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              Ordered By <span className="login-danger">*</span>
            </label>
            <Dropdown
              value={form.master_id}
              options={orderByData?.map((e) => ({
                label: e.name,
                value: e._id,
              }))}
              onChange={(e) =>
                handleChange({ target: { name: "master_id", value: e.value } })
              }
              placeholder="Select Ordered By"
              filter
              className="w-100"
            />
            {error.master_id && <div className="error">{error.master_id}</div>}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>Freight Amount (₹)</label>
            <input
              type="number"
              name="freight_amount"
              placeholder="Enter freight amount"
              value={form?.freight_amount || ""}
              onChange={handleChange}
              className="form-control"
            />
          </div>
        </div>
        <div className="col-12 ">
          <div className="input-block local-forms">
            <label>Reason/Purpose</label>
            <textarea
              type="text"
              className="form-control"
              rows={4}
              onChange={handleChange}
              name="remarks"
              placeholder="Remarks"
              value={form.remarks}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PurchaseOrderFields;
